import { userConstants } from '../constants'
import { StorageService } from '../services'

let user = StorageService.authentication.user.get()
const initialState = user || null

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case userConstants.LOGIN:
			return {
				...action.user,
			}
		case userConstants.LOGOUT:
			return null

		case userConstants.UPDATE_PLAN:
			return {
				...state,
				plan: action.payload,
			}
		case userConstants.SET_ACCESS_TOKEN:
			return {
				...state,
				accessToken: action.payload,
			}
		default:
			return state
	}
}
